import React from 'react';
import { container } from 'tsyringe';
import { LaporanKepesantrenanPresenter } from '../../../../../../data/presenters/LaporanKepesantrenanPresenter';
import { toast } from 'react-toastify';

interface RekapData {
  total: number;
  dari_pesantren: number;
  by_peran: Array<{ peran: string; jumlah: number }>;
  by_provinsi: Array<{ nama_provinsi: string; jumlah: number }>;
  by_mukim: Array<{ status_mukim: number; jumlah: number }>;
}

interface IState {
  isLoading: boolean;
  isLoadingPelatihan: boolean;
  rekapData: RekapData | null;
  listPelatihan: Array<{ id: number; judul_pelatihan: string }>;
  selectedPelatihanId: string;
}

interface InitialState {
  state: IState;
  fetchRekap: Function;
  fetchPelatihan: Function;
  setSelectedPelatihanId: Function;
}

const initialState: InitialState = {
  state: {
    isLoading: false,
    isLoadingPelatihan: false,
    rekapData: null,
    listPelatihan: [],
    selectedPelatihanId: '',
  },
  fetchRekap: () => {},
  fetchPelatihan: () => {},
  setSelectedPelatihanId: () => {},
};

const Context = React.createContext<InitialState>(initialState);
const { Provider: RekapKepesantrenanController } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({ ...initialState.state });

  const setLoading = (value: boolean) =>
    setState((prev) => ({ ...prev, isLoading: value }));

  const fetchRekap = async (pelatihanId?: string) => {
    setLoading(true);
    try {
      const presenter = container.resolve(LaporanKepesantrenanPresenter);
      const data = await presenter.getRekap(pelatihanId || undefined);
      setState((prev) => ({ ...prev, rekapData: data, isLoading: false }));
    } catch (error: any) {
      console.log('error fetch rekap kepesantrenan :', error);
      toast.error('Gagal memuat data rekap', {
        style: { boxShadow: '0px 1px 6px #F86E70' },
      });
      setLoading(false);
    }
  };

  const fetchPelatihan = async () => {
    setState((prev) => ({ ...prev, isLoadingPelatihan: true }));
    try {
      const presenter = container.resolve(LaporanKepesantrenanPresenter);
      const data = await presenter.getPelatihanPesantren();
      setState((prev) => ({ ...prev, listPelatihan: data, isLoadingPelatihan: false }));
    } catch (error: any) {
      console.log('error fetch pelatihan pesantren :', error);
      setState((prev) => ({ ...prev, isLoadingPelatihan: false }));
    }
  };

  const setSelectedPelatihanId = (id: string) => {
    setState((prev) => ({ ...prev, selectedPelatihanId: id }));
    fetchRekap(id);
  };

  return (
    <RekapKepesantrenanController
      value={{
        state,
        fetchRekap,
        fetchPelatihan,
        setSelectedPelatihanId,
      }}
    >
      {children}
    </RekapKepesantrenanController>
  );
};

export const useRekapKepesantrenan = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useRekapKepesantrenan,
  Provider,
};
